Vue.component('ack-page-loading', {
	delimiters: ['${', '}$'],
	template: '#ack-page-loading',
	mounted() {},
	props: {
		// isMobile: {
		// 	type: Boolean,
		// 	required: true,
		// },
		pageIsLoading: {
			type: Boolean,
			required: true,
		},
	},
	computed: {},
	data() {
		return {
			pageId: 'page-loading',
		};
	},
	methods: {},
	beforeDestroy() {},
	watch: {},
});
